import angular from 'angular';

class TabPanelController {
  static $inject = ['$element'];
  name: string;

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-tab-panel');

    if (!this.name) {
      throw new Error('acmeTabPanel.name is required');
    }
  }
}

export const TabPanelComponentModule = angular
  .module('acme.common.component.tabs.tabPanel', [])
  .component('acmeTabPanel', {
    templateUrl: 'common/components/tabs/tab-panel.component.tpl.html',
    controller: TabPanelController,
    require: {
      tabsCtrl: '^acmeTabs',
    },
    transclude: true,
    bindings: {
      name: '<',
    },
  }).name;
